module.exports = __webpack_public_path__ + "289fba89713ec7ad5e7bd365d3e3cfba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camscreen2.jpg
// module id = 167
// module chunks = 0